/* iceberg-ui */
import { Badge, BadgeVariant, Flex } from '@auviknetworks/iceberg-ui';

/*  React  */
import { CellContext } from '@tanstack/react-table';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * A React component that renders a badge in a table cell.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.cell - The cell object containing the data.
 * @param {string} [props.badgeVariants] - The key - iceberg badge variant object.
 *
 * @returns {React.ReactElement} The rendered table cell component.
 */
export const BadgeCell = <TData,>({
    cell,
    badgeVariants
}: CellContext<TData, unknown> & {
    badgeVariants?: Record<string, BadgeVariant>;
}): React.ReactElement | null => {
    const { t } = useTranslation();

    const value = cell.getValue();

    if (!value) return null;

    // Convert to array if it's not already an array
    const arrayValue = Array.isArray(value) ? value : [value];

    return (
        <Flex sx={{ flexWrap: 'wrap', gap: '4px' }}>
            {arrayValue.map((item: string) => (
                <Badge
                    key={item}
                    variant={badgeVariants?.[item] ?? 'primary'}
                    text={t(`Tags.${item}`)}
                />
            ))}
        </Flex>
    );
};
